import { jsxs, jsx } from 'react/jsx-runtime';
import * as React from 'react';
import styled from '@emotion/styled';
import { space } from '../../constants.js';
import { Flex } from '../Flex/Flex.js';
import { Box } from '../Box/Box.js';

const INTERVAL = 130;
const FRAMES = [
    "\u2014",
    "\\",
    "|",
    "/"
];
const SLabel = styled.span({
    marginLeft: space.s2,
    "&.reverse": {
        order: -1,
        marginLeft: "unset",
        marginRight: space.s2
    }
});
const Spinner = ({ label, pause = false, reverseLabel, ...restProps })=>{
    const [frameIndex, setFrameIndex] = React.useState(0);
    const nextFrame = React.useCallback(()=>!pause && setFrameIndex((frameIndex + 1) % FRAMES.length), [
        frameIndex,
        pause
    ]);
    React.useEffect(()=>{
        const interval = setInterval(()=>nextFrame(), INTERVAL);
        return ()=>clearInterval(interval);
    }, [
        nextFrame
    ]);
    return jsxs(Flex, {
        alignItems: "baseline",
        "data-testid": "loading-spinner",
        display: "inline-flex",
        ...restProps,
        children: [
            jsx(Box, {
                as: "span",
                monospace: true,
                role: "presentation",
                children: FRAMES[frameIndex]
            }),
            label ? jsx(SLabel, {
                className: reverseLabel ? "reverse" : "",
                children: label
            }) : null
        ]
    });
};

export { Spinner };
